<template>
  <el-dialog
    class="init-node-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <!-- <el-form-item label="节点名称" prop="NodeName" class="special-item">
        <el-input v-model="editForm.NodeName" placeholder="请输入"></el-input>
      </el-form-item> -->

      <el-form-item label="节点身份标识（公钥）" prop="NodeName">
        <template slot="label">
          <span
            >节点身份标识（公钥）
            <el-tooltip class="item" effect="dark" placement="right">
              <i class="el-icon-question common-icon"></i>
              <div slot="content">
                <p>用于生成公钥的身份标识信息</p>
              </div>
            </el-tooltip>
          </span>
        </template>
        <el-input v-model="editForm.NodeName"></el-input>
      </el-form-item>
      <el-form-item label="选择组织" prop="OrgId" class="special-item" >
        <el-select
          v-model="editForm.OrgId"
          placeholder="请选择"
          clearable
          class="auto-width"
          @change="handleSelect"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="节点角色" prop="Role" >
        <el-select v-model="editForm.Role" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'InitNodeCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 200
  },
  data() {
    let validateNode = (rule, value, callback) => {
      let reg = /^(?!(\d+)$)[\u4e00-\u9fffa-zA-Z\d\-_.]{0,30}$/
      if (value === '') {
        callback(new Error('请填写节点身份标识（公钥）'))
      } else if (!reg.test(value)) {
        callback(
          new Error('请输入30位以内字母、数字、汉字、中横线、下划线、小数点组合，不能为纯数字')
        )
      } else {
        callback()
      }
    }
    return {
      disabled: false,
      title: '申请IBC节点证书',
      dialogVisible: false,
      editForm: {
        NodeName: '',
        OrgId: '',
        Role: 4,
        Type: 1,
        OrgName: ''
      },
      editRules: {
        NodeName: [{ required: true, validator: validateNode, trigger: 'blur' }],
        OrgId: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        Role: [{ required: true, message: '请选择节点角色', trigger: 'blur' }]
      },
      options: [],
      roleOptions: [
        { label: '共识节点', value: 4 },
        { label: '普通节点', value: 5 }
      ],
      adaptationVars: {
        formLabelWidth: 200
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getOrgList({ limit: 50, offset: 0, certType: 0 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.editForm = {
        NodeName: '',
        OrgId: '',
        OrgName: '',
        Role: 4,
        Type: 1
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleSelect(val) {
      let item = this.options.filter(ele => ele.OrgId === val)
      this.editForm.OrgName = item[0]['OrgName'] || ''
    },
    handleOk() {
      this.disabled = true
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate
            .initNode(this.editForm)
            .then(res => {
              this.$message.success('申请节点证书成功！')
              this.$emit('update:list')
              this.handleCancel()
            })
            .catch(err => {
              this.disabled = false
              return
            })
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.init-node-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
  .common-icon {
    vertical-align: middle;
    font-size: var(--base-font-size-large);
  }
}
</style>
